import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editPreparationItemCategoryDialog from '../dialog.editPreparationItemCategoryDialog';
import editPreparationItemDialog from '../dialog.editPreparationItemDialog';
import controller from './preparation-item-category.controller';
import directive from './preparation-item-category.directive';
import preparationItem from '../preparationItem';


export default angular.module('app.components.advisory.auditTrail.preparationItemCategory', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  editPreparationItemCategoryDialog,
  editPreparationItemDialog,
  loaderService,
  orgDataService,
  preparationItem,
  ssDialogService,
  userService,
])
  .directive('amPreparationItemCategory', directive)
  .controller('PreparationItemCategoryController', controller)
  .name;

console.log('app.components.advisory.auditTrail.preparationItemCategory created');
